import { render, staticRenderFns } from "./TournamentsResults.vue?vue&type=template&id=0738c7f6"
import script from "./TournamentsResults.vue?vue&type=script&lang=js"
export * from "./TournamentsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports